import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import type { Form, FormField } from '../../../interfaces/form.interface';
import { REACTIVE_FORM_BUILDER_BROWSER } from '../../../adapters/reactive-form-builder.adapters';

@Component({
    selector: 'app-reactive-textarea-field',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './textarea-field.component.html',
})
export class ReactiveTextareaFieldComponent<T> {
    @Input() field!: FormField<T>;

    @Input() form!: Form<T>;

    @Input() model!: FormGroup;

    @Input() isEditable = false;

    @Input() describedById = '';

    @Input() isInvalid = false;

    public readonly browser = inject(REACTIVE_FORM_BUILDER_BROWSER);

    public getAudio(field: string | number, event: string): void {
        this.model.patchValue({ [field]: event });
    }

    public updateImageModel(event: string, fieldName: string): void {
        this.model.patchValue({ [fieldName]: event });
    }
}
